import { NO_DATA } from 'constants/common'
import { ReactNode } from 'react'

interface IProps {
  children?: ReactNode
}
const Value = ({ children }: IProps) => {
  return <>{children ?? NO_DATA}</>
}

export default Value
